<template>
  <svg class="fill-current stroke-current" version="1.1" id="Camada_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 133.31 133.31" style="enable-background:new 0 0 133.31 133.31;" xml:space="preserve">
    <path class="st1" d="M84.14,119.2H49.16c-6.73,0-12.18-5.45-12.18-12.18V25.36c0-6.73,5.45-12.18,12.18-12.18h34.98
        c6.73,0,12.18,5.45,12.18,12.18v81.66C96.32,113.75,90.87,119.2,84.14,119.2z"/>
    <path class="st1" d="M81.81,25.43H51.5c-1.46,0-2.65,1.19-2.65,2.65v30.31c0,1.46,1.19,2.65,2.65,2.65h30.31
        c1.46,0,2.65-1.19,2.65-2.65V28.08C84.46,26.62,83.27,25.43,81.81,25.43z"/>
    <path class="st2" d="M81.98,81.87H51.33c-1.37,0-2.48,1.11-2.48,2.48l0,0c0,1.37,1.11,2.48,2.48,2.48h30.65
        c1.37,0,2.48-1.11,2.48-2.48l0,0C84.46,82.98,83.35,81.87,81.98,81.87z"/>
    <path class="st2" d="M73.56,70.3H59.75c-1.37,0-2.48,1.11-2.48,2.48l0,0c0,1.37,1.11,2.48,2.48,2.48h13.82
        c1.37,0,2.48-1.11,2.48-2.48l0,0C76.04,71.4,74.93,70.3,73.56,70.3z"/>
    <path class="st2" d="M81.98,93.9H51.33c-1.37,0-2.48,1.11-2.48,2.48v0c0,1.37,1.11,2.48,2.48,2.48h30.65c1.37,0,2.48-1.11,2.48-2.48
        v0C84.46,95.01,83.35,93.9,81.98,93.9z"/>
    <path class="st2" d="M81.98,105.93H51.33c-1.37,0-2.48,1.11-2.48,2.48v0c0,1.37,1.11,2.48,2.48,2.48h30.65
        c1.37,0,2.48-1.11,2.48-2.48v0C84.46,107.04,83.35,105.93,81.98,105.93z"/>
    </svg>
</template>
<style scoped type="text/css">
    .st1{fill:none;stroke:#606060;stroke-width:5;stroke-miterlimit:10;}
    .st4{fill:none;stroke:#606060;stroke-width:4.0965;stroke-miterlimit:10;}
</style>
